import backend from "../../api/api";
import { store } from "../../redux/store";

const getConfig = () => {
  const token = store.getState().auth.token;

  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  return config;
};

export const createpage = (formValues) => async (dispatch) => {
  try {
    const response = await backend.post(
      `api/ecommerce/page/`,
      formValues,
      getConfig()
    );
    if (response.status === 201) {
      return response.data;
    }
  } catch (error) {
    alert(error);
  }
};

export const getAllpage = (is_campaign_page = false) => async (dispatch) => {
  try {
    const response = await backend.get(`api/ecommerce/page/?is_campaign_page=${is_campaign_page}`, getConfig());
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log(error);
  }
};

export const getAllCampaignPage = (is_campaign_page = true) => async (dispatch) => {
  try {
    const response = await backend.get(`api/ecommerce/page/?is_campaign_page=${is_campaign_page}`, getConfig());
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log(error);
  }
};

export const getSpecificpage = (id) => async (dispatch) => {
  try {
    const response = await backend.get(
      `api/ecommerce/page/${id}/`,
      getConfig()
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log(error);
  }
};

export const getSpecificCampaignpage = (slug = "") => async (dispatch) => {
  try {
    const response = await backend.get(
      `api/ecommerce/page/?slug=${slug}`,
      getConfig()
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log(error);
  }
};

export const updatepage = (id, formValues) => async (dispatch) => {
  try {
    const response = await backend.put(
      `api/ecommerce/page/${id}/`,
      formValues,
      getConfig()
    );
    if (response.status === 202) {
      return response.data;
    }
  } catch (error) {
    console.log(error);
  }
};

export const deletepage = (id) => async (dispatch) => {
  try {
    const response = await backend.delete(
      `api/ecommerce/page/${id}/`,
      getConfig()
    );
    if (response.status === 204) {
      return true;
    }
  } catch (error) {
    console.log(error);
  }
};
